import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

const Success = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  // TODO: Track Purchase only after verifying this Stripe session server-side.
  return (
    <div className="min-h-[calc(100vh-90px)] bg-mmPage flex flex-col items-center justify-center text-center px-6 py-16">
      <div className="bg-mmSurface border border-green-500/70 px-8 py-10 rounded-2xl shadow-sm max-w-md w-full">
        <div className="flex justify-center mb-4">
          <FaCheckCircle className="text-green-400 text-5xl" />
        </div>
        <h1 className="text-mmText text-2xl font-display uppercase tracking-widest mb-4">
          Betaling ontvangen
        </h1>
        <p className="text-mmTextMuted leading-relaxed mb-6 text-base md:text-lg">
          Je ontvangt binnen enkele minuten een e-mail met je downloadlinks en
          eventuele vervolgstappen. Controleer ook je spam- of reclamefolder
          als je niets ziet.
        </p>

        {sessionId && (
          <p className="text-mmTextMuted text-xs break-all mb-6">
            Referentie:{" "}
            <span className="text-mmAccent font-semibold">{sessionId}</span>
          </p>
        )}

        <p className="text-mmTextMuted text-sm leading-relaxed mb-6">
          Heb je na 10 minuten nog niets ontvangen? Neem dan contact op via{" "}
          <a
            href="mailto:mission.movement@outlook.com"
            className="text-mmAccent hover:opacity-80"
          >
            mission.movement@outlook.com
          </a>
          .
        </p>

        <Link to="/" className="mm-btnPrimary inline-flex justify-center">
          Terug naar home
        </Link>
      </div>
    </div>
  );
};

export default Success;
